export default __webpack_public_path__ + "static/media/muirwoods.4c364c8b.jpg";